import { createSlice, createAsyncThunk, createEntityAdapter, } from '@reduxjs/toolkit'
import {envAwarePost, envAwareFormSubmit} from '../../util/util'

export const initUser = createAsyncThunk(
	'user/initUser',
	async () => envAwarePost( 'api/initReactApp/', 
	{
		action:'getInitData'
	})
)

export const downgradeClientToProspect = createAsyncThunk(
	'downgradeClientToProspect',
	async id => await envAwarePost(
		'api/users/',
		{action:'downgradeClientToProspect',id}
	)
)

export const createProspectiveClient = createAsyncThunk(
	'createProspectiveClient',
	async payload => await envAwarePost(
		'api/users/',
		{action:'createProspectiveClient',...payload}
	)
)

export const convertProspectiveClient = createAsyncThunk(
	'convertProspectiveClient',
	async (payload,{dispatch}) => {
		const res = await envAwarePost(
			'api/users/',
			{action:'convertProspectiveClient',...payload}
		)
		if(res){
			dispatch(getAllClients())
		}
		return res
	}
)

/**
 * This is for trainers
 */
export const deleteProgramAssignment = createAsyncThunk(
	'deleteProgramAssignment',
	async payload => envAwarePost('api/programs/api/', {
		action: 'deleteProgramAssignment',
		...payload
	})
)

export const editTrainerPageAddress = createAsyncThunk(
	'editTrainerPageAddress',
	async pageAddress => await envAwarePost(
		'api/users/',
		{action:'updateProfileData',field:'pageAddress',value:pageAddress}
	)
)

export const editLogo = createAsyncThunk(
	'editLogo',
	async logo => await envAwarePost(
		'api/users/',
		{action:'updateProfileData',field:'logo_url',value:logo}
	)
)

export const editBioData = createAsyncThunk(
	'editBioData',
	async payload => await envAwarePost(
		'api/users/',
		{
			action:'updateProfileData',
			field:payload.field,
			value:payload.value
		}
	)
)

export const getAllTrainers = createAsyncThunk(
	'users/getAllTrainers',
	async payload => envAwarePost('api/users/api/', {
			action: 'getAllTrainers',
			...payload
		})
)

export const getAllClients = createAsyncThunk(
	'users/getAllClients',
	async payload => await envAwarePost(
		'api/users/api/',
		{
			action:'getAllClients',
			include_compliance:1,
			...payload
		}
	)
)

export const getClient = createAsyncThunk(
	'users/getClient',
	async client_id => await envAwarePost(
		'api/users/api/',
		{action:'getClient',client_id}
	)
)

export const getClubReadyIdBarcode = createAsyncThunk(
	'users/getClubReadyIdBarcode',
	async client_id => await envAwarePost(
		'api/users/api/',
		{action:'getClubReadyIdBarcode',client_id}
	)
)

export const createClubReady = createAsyncThunk(
	'users/createClubReady',
	async payload => await envAwarePost(
		'api/users/api/',
		{action:'createClubReady',...payload}
	)
)

export const updateProfileData = createAsyncThunk(
	'users/updateProfileData',
	async payload => await envAwareFormSubmit({
		path:'api/users/api',
		payload:{
			...payload
		}
	})
)

export const updateTimeSettings = createAsyncThunk(
	"updateTimeSettings",
	async (payload) => envAwarePost("api/user/api.php",{
	  action: "updateTimeSettings",
		  ...payload
	})
)

export const createClient = createAsyncThunk(
	'users/createClient',
	async payload => await envAwareFormSubmit({
		path:'api/users/api',
		payload:{
			action:'createClient',
			...payload
		}
	})
)

export const deleteClient = createAsyncThunk(
	'users/deleteClient',
	async client_id => envAwarePost("api/users/", {
		action:'removeClient',
		client_id
	})
)

export const removeTagFromClient = createAsyncThunk(
	'users/removeTagFromClient',
	async payload => envAwarePost('api/users/api/',{
		action:'removeTagFromClient',
		...payload
	})
)

export const getGenericAutomation = createAsyncThunk(
	'getGenericAutomation',
	async () => envAwarePost('api/init/api/',{
		action:'getInitData'
	})
)

export const showProspects = createAsyncThunk(
    'users/prospectHandler', 
    async () => envAwarePost("api/users/", {
        action: "getProspectiveClients",
    })
)

export const getLoginInfo = createAsyncThunk(
    'users/getLoginInfo', 
    async (payload) => envAwarePost("api/users/api", {
        action: "getLoginInfo",
		...payload
    })
)

export const updateClientAccountStatus = createAsyncThunk(
    'updateClientAccountStatus', 
    async (payload) => envAwarePost("api/users/api", {
       ...payload, action: "updateClientAccountStatus",
    })
)

export const updateTrainerPageColors = createAsyncThunk(
	'updateTrainerPageColors',
	async payload => await envAwarePost(
		'api/users/',
		{action:'updateTrainerPageCustomizer',...payload}
	)
)

export const updateChosenTemplate = createAsyncThunk(
	'updateChosenTemplate',
	async value => await envAwarePost(
		'api/users/',
		{action:'updateChosenTemplate',value}
	)
)

export const bulkTagClients = createAsyncThunk(
	'bulkTagClients',
	async payload => await envAwarePost(
		'api/users/',
		{actions:['bulkTagClients','getAllClients'],...payload}
	)
)

export const updateClientProfileData = createAsyncThunk(
	'updateClientProfileData',
	async payload => await envAwarePost(
		'api/users/',
		{
			action:'updateClientProfileData',
			//will us s3
			using_s3:1,
			...payload
		}
	)
)

export const updateTrainerPermissions = createAsyncThunk(
	'editPermissions',
	async payload => await envAwarePost(
		'api/permissions/',
		{
			action:'editPermissions',
			...payload
		}
	)
)

const genericProgramAutomationAdapter = createEntityAdapter()

const trainersAdapter = createEntityAdapter({
	selectId:ent=>ent.user_id_number
})

const clientsAdapter = createEntityAdapter({
	selectId:ent=>ent.user_id_number
})

const usersAdapter = createEntityAdapter({
	selectId:ent=>ent.user_id_number,
	status:'idle',
})

const usersSlice = createSlice({
	name: 'users',
	initialState:{
		status:'empty',
		current_user:null,
		customBranding:null,
		trainerProfileImg:null,
		//store map of pending user calls
		//eg getClient
		pending:{},
		prospects: {
			show: false,
			recent: [],
			status: null,
		},
		trainers: trainersAdapter.getInitialState({
			status:'init'
		}),
		clients: clientsAdapter.getInitialState({
			status:'init'
		}),
		all: usersAdapter.getInitialState(),
		generic_program_automation: genericProgramAutomationAdapter.getInitialState(),
	},
	reducers: {
		premiumTemplateChosen:(state)=>{
			//auto select premium template
			state.current_user.bio_data.chosen_template='premium'
		},
		setClientKey:(state,action)=>{
			const {key,clientId,val} = action.payload
			usersAdapter.updateOne(state.clients,{
				id:clientId,
				changes:{[key]:val}
			})
		},
		setCurrentUser : (state, action) => {
			state.current_user = action.payload
		},
		addTagToClient: (state, action) => {
			console.log(action.payload)
			const {clientId,tag} = action.payload
			//state.adapter.entities[data.note_id] = data
			//state.adapter.ids.unshift(data.note_id)
			state.clients.entities[clientId].tags.push(tag)

		},
		clearTrainerNewMessageFlag:(state,action)=>{
			const client_id = action.payload
			usersAdapter.updateOne(state.clients,{
				id:client_id,
				changes:{trainerNewMessageFlag:0}
			})
		},
		hideProspects:(state,action) => {
            state.prospects.show = false;
        }
	},
	extraReducers: {
		[initUser.fulfilled] : (state,action)=>{
			const {user} = action.payload
			state.current_user = user
		},
		[getClient.pending] : (state,action)=>{
			const user_id_number = action.meta.arg
			state.pending[user_id_number] = true
		},
		[getClient.fulfilled] : (state,action)=>{
			const user_id_number = action.meta.arg
			state.pending[user_id_number] = false
			clientsAdapter.upsertOne(state.clients,action.payload.data)
			usersAdapter.upsertOne(state.all,action.payload.data)
		},
		[deleteClient.pending] : (state,action) => {
			const client_id = action.meta.arg
			usersAdapter.removeOne(state.clients,client_id)
		},
		[updateTimeSettings.pending]: (state, action) => {
			const { is_24_hour_time } = action.meta.arg
			state.current_user.is_24_hour_time = is_24_hour_time
		},
		[getAllTrainers.pending]: (state, action) => {
			state.trainers.status = 'pending'
		},
		[getAllTrainers.fulfilled]: (state, action) => {
			const { success, data } = action.payload
			state.trainers.status = 'idle'
			if(success === '1'){
				trainersAdapter.upsertMany(state.trainers,data)
				usersAdapter.upsertMany(state.all,data)
			}
		},
		[getAllClients.pending] : (state)=>{
			state.clients.status = 'pending'
		},
		[getAllClients.fulfilled] : (state,action)=>{
			const {success,data} = action.payload
			state.clients.status = 'idle'
			if(success === '1'){
				clientsAdapter.upsertMany(state.clients,data)
				usersAdapter.upsertMany(state.all,data)
			}
		},
		[removeTagFromClient.pending]: (state, action) => {
			const { tag_id, client_id } = action.meta.arg
			//remove first instance of the tag
			const tags = state.clients.entities[client_id].tags
			const idx = tags.findIndex(tag=>tag.id===tag_id)
			const tagsUpdate = [
				...tags.slice(0,idx),
				...tags.slice(idx+1)
			]
			clientsAdapter.updateOne(state.clients,{
				id:client_id,
				changes:{
					tags:tagsUpdate
				}
			})
		},
		[getGenericAutomation.fulfilled]: (state, action) => {
			const { success, data, message } = action.payload;
			if(success === '1'){
				genericProgramAutomationAdapter.upsertMany(state.generic_program_automation,data)
			}else{
				alert(message)
			}
		},
		[showProspects.pending] : (state,action) => {
            state.prospects.show = true;
            state.prospects.status = "loading"
        },
		[showProspects.fulfilled] : (state,action) => {
            state.prospects.recent = action.payload.data.clients;
            state.prospects.status = "idle"

        },
        [deleteProgramAssignment.pending] : (state,action) => {
        	const {client_id,assignment_id} = action.meta.arg
        	//some legacy functionality uses the deprecated 'clients' list
        	const keys = ['clients','all']
        	keys.forEach(key=>{
        		const assigned_programs = state[key].entities[client_id].assigned_programs
	        	state[key].entities[client_id].assigned_programs = assigned_programs.filter(p=>(
	        		p.id!==assignment_id
	        	))
        	})
        },
        [editTrainerPageAddress.pending] : (state,action)=>{
        	const pageAddress = action.meta.arg
        	state.current_user.bio_data.pageAddress = pageAddress
        },
        [editLogo.pending] : (state,action)=>{
        	const logo = action.meta.arg
        	state.current_user.bio_data.img = logo
        },
        [editBioData.pending] : (state,action)=>{
        	const {field,value} = action.meta.arg
        	state.current_user.bio_data[field] = value
        },
        [updateTrainerPageColors.pending] : (state,action)=>{
			const {backgroundColor,textButtonColor,buttonTextColor} = action.meta.arg
			if (Boolean(backgroundColor)) {
				state.current_user.bio_data.background_color = backgroundColor
			}
			if (Boolean(textButtonColor)) {
				state.current_user.bio_data.text_button_color = textButtonColor
			}
			if (Boolean(buttonTextColor)) {
				state.current_user.bio_data.buttontext_color = buttonTextColor
			}
        },
        [updateChosenTemplate.pending] : (state,action)=>{
        	state.current_user.bio_data.chosen_template = action.meta.arg
        },
        [bulkTagClients.fulfilled] : (state,action)=>{
        	const {success,getAllClients} = action.payload
			state.clients.status = 'idle'
			if(success === '1'){
				clientsAdapter.upsertMany(state.clients,getAllClients.data)
				usersAdapter.upsertMany(state.all,getAllClients.data)
			}
        },
        [createProspectiveClient.fulfilled] : (state,action)=>{
        	state.prospects.recent.unshift(action.payload.data.prospective_client)
        },
        [updateClientProfileData.pending] : (state,action)=>{
        	const {id,update:changes} = action.meta.arg
        	//prevent password from getting stored in redux
        	//by removing it from the changes we put into 
        	//the redux uptate
        	const {password,...safeChanges} = changes
        	clientsAdapter.updateOne(state.all,{id,changes:safeChanges})
        },
        [updateTrainerPermissions.pending] : (state,action)=>{
        	const {apply_to_all_trainers,trainer_ids,update} = action.meta.arg

        	const ids = apply_to_all_trainers ? state.trainers.ids : trainer_ids

        	ids.forEach(id=>{
        		const trainer = state.trainers.entities[id]
        		trainer.permissions = {
        			...trainer.permissions,
        			...update
        		}
        	})
        },
        [downgradeClientToProspect.pending] : (state,action)=>{
        	const id = action.meta.arg
			usersAdapter.removeOne(state.clients,id)
        }
	}
})

export const {
	setClientKey,
	addTagToClient,
	clearTrainerNewMessageFlag,
	setCurrentUser,
	premiumTemplateChosen,
	hideProspects
} = usersSlice.actions

export const selectTrainerParam = state => (
	//a gym logged in as a trainer will have both of these set to 1
	(state.users?.current_user?.trainer == 1) && (state.users?.current_user?.gym == 1) ?
	`trainer=${state.users.current_user.user_id_number}` :
	''
)

export const selectGymAsTrainer = state => (
	state.users.current_user.trainer === '1' &&
	state.users.current_user.gym === '1' 
)

export const {
	selectAll: selectAllGenericAutomation,
	selectById: selectAllGenericAutomationById,
} = genericProgramAutomationAdapter.getSelectors(state => state.todaysEvents.generic_program_automation)

export const {
	selectAll: selectAllUsers,
	selectById: selectUserById,
	selectIds: selectUsersIds
} = usersAdapter.getSelectors(state => state.users.all)

export const {
	selectAll: selectAllTrainers,
	selectById: selectTrainersById,
	selectIds: selectTrainerIds
} = trainersAdapter.getSelectors(state => state.users.trainers)

export const {
	selectAll: selectAllClients,
	selectById: selectClientsById,
	selectIds: selectClientsIds
} = clientsAdapter.getSelectors(state => state.users.clients)


export default usersSlice.reducer